import * as React from "react";
import { NavLink } from "react-router-dom";

type Props = {
  align?: string;
  tag: string;
  text: string;
  class?: string;
  style?: any;
  id?: string;
  link?: string;
  active?: string;
  onClick?: any;
};

export default class BOText extends React.Component<Props, any> {
  static defaultProps = {
    align: "left", // left | center | right
    tag: "span", // span | h1 - h6 | p
    text: "",
    class: "",
    style: {},
    id: "",
    link: "",
    active: "",
    onClick: null
  };

  constructor(props: any) {
    super(props);

    this.Create = this.Create.bind(this);
  }
  Create(): any {
    const { tag, text, align, id, style, link, active, onClick } = this.props;
    var Obj = {};
    const Props = {
      style: { textAlign: align },
      className: "BOText "
    };

    if (onClick) {
      Props["onClick"] = onClick;
    }
    if (this.props.class) {
      Props["className"] += this.props.class;
    }
    if (id) {
      Props["id"] = id;
    }
    Props["style"] = style ? style : { minWidth: "0" };

    Obj = React.createElement(tag, Props, text);

    if (link !== "") {
      Obj = React.createElement(
        NavLink,
        {
          to: link,
          activeClassName: active ? active : "",
          style: {
            textDecoration: "none"
          },
          className: "BOTextLink"
        },
        Obj
      );
    }

    return Obj;
  }
  render(): JSX.Element {
    return this.Create();
  }
}
